import { KeyTextField } from '@prismicio/client';
import styles from './loadMoreButton.module.scss';

interface LoadMoreButtonProps {
  text: string | KeyTextField;
  onClick: () => void;
}

export const LoadMoreButton = ({ text, onClick }: LoadMoreButtonProps) => {
  return (
    <div className={styles.button_wrapper}>
      <button type="button" className={styles.button} onClick={onClick}>
        <div className={styles.text_wrapper}>
          <span>{text}</span>
          <span>{text}</span>
        </div>
      </button>
    </div>
  );
};
